import * as React from 'react'
import classNames from 'classnames'

import ArrowDown from 'ui-component-library/icons/arrow-down.svg'

import style from './style.scss'

type Props = {
  className?: string
  expandText: string
  isExpanded: boolean
  onToggle: () => void
}

MoreLessToggle.defaultProps = {
  className: '',
}

function MoreLessToggle(props: Props) {
  const { className, expandText, isExpanded, onToggle } = props

  return (
    <button
      className={classNames(
        style.wrapper,
        {
          [style.expanded]: isExpanded,
        },
        className,
      )}
      onClick={onToggle}
    >
      <span>
        {expandText}
        <ArrowDown className={style.arrowIcon} />
      </span>
    </button>
  )
}

export default MoreLessToggle
